import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationDocuments } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { UploadDocuments } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/UploadDocuments';
import { DocumentsModal } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/components/DocumentsModal';
import { Button } from '@mantine/core';
import { DOCUMENT_LIBRARY_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { SelectedDocument } from '@dealstack/frontend/app/pages/Project/DocumentLibrary/types';

interface Props {
	dealId: string;
	setIsUploadActive: (isUploadActive: boolean) => void;
	isUploadActive: boolean;
	onViewExistingDocument: (existingDocument: SelectedDocument) => void;
}

export const DashboardHeader = ({
	dealId,
	setIsUploadActive,
	isUploadActive,
	onViewExistingDocument,
}: Props) => {
	const tDocuments = useTranslationDocuments();

	return (
		<>
			<Button
				data-testid={DOCUMENT_LIBRARY_ELEMENT_ID.ADD_TO_LIBRARY_BUTTON}
				leftSection={<Icon variant="add" size="lg" />}
				onClick={() => setIsUploadActive(true)}
			>
				{tDocuments('documents.library.add_to_document_library')}
			</Button>
			<DocumentsModal
				isOpen={isUploadActive}
				onClose={() => setIsUploadActive(false)}
				title={tDocuments('document.upload_state.header')}
			>
				<UploadDocuments
					dealId={dealId}
					setIsUploadActive={setIsUploadActive}
					onViewExistingDocument={onViewExistingDocument}
				/>
			</DocumentsModal>
		</>
	);
};
